@if (paramDetail.initialize === true) {
  <div>
    <!-- Dock bannette : index bannette, commentaires, pj -->
    <p-tabView scrollable (onChange)="handleChange($event)" [activeIndex]="tabview">
        <p-tabPanel>
            <ng-template pTemplate="header">{{'View' | translate}}</ng-template>
            <div class="grid h-full">
                    <div class="col-12 max-pdfsplit">
                <pdf-preview [pathPdf]="pathPdf" style="position: relative"></pdf-preview>
                    </div>
            </div>
        </p-tabPanel>
      @if (paramDetail.bskMode) {
        <p-tabPanel>
          <ng-template pTemplate="header">{{'Basket' | translate}}</ng-template>
          <!-- Dock Mail -->
          <infosmail [visuMode]="!editMode" [bskTypeMail]="paramDetail.bskTypeMail" [infosMailDisplay]="paramDetail.infosMailDisplay"></infosmail>
          <div class="flex flex-wrap">
            <!-- 1 ere col -->
            <div class="flex flex-wrap flex-column md:flex-wrap"
                [ngClass]="{
                    'col-display-1': paramDetail.nbZoneDisplay.nbBskLeft >= 1,
                    'col-display-2': paramDetail.nbZoneDisplay.nbBskLeft >= 1 && paramDetail.nbZoneDisplay.nbBskRight >= 1,
                    'col-display-false': paramDetail.nbZoneDisplay.nbBskLeft === 0
                    }">
              <!-- 1er ele -->
              @if (paramDetail.currentSelectedBsk.bskTypeDock === 'InvoiceValidation') {
                <div class="col-12">
                  <inputvalue
                    [title]="'Val_Fac' | translate"
                    [dataVariableList]="paramDetail.bskParamDock.varList"
                    [libAction]="true"
                    [editorService]="paramDetail.editorService"
                    [visuMode]="!editMode"
                    >
                  </inputvalue>
                </div>
              }
              @if (paramDetail.currentSelectedBsk.bskTypeDock === 'MailDispatching') {
                <div class="col-12">
                  <inputvalue
                    [title]="'Mail_Dist' | translate"
                    [dataVariableList]="paramDetail.bskParamDock.varList"
                    [libAction]="true"
                    [editorService]="paramDetail.editorService"
                    [visuMode]="!editMode"
                    >
                  </inputvalue>
                  <dockmail
                    [editMode]="!editMode"
                    [userList]="paramDetail.bskParamDock.srcList"
                    [destList]="paramDetail.bskParamDock.trgList"
                    >
                  </dockmail>
                </div>
              }
              @if (paramDetail.currentSelectedBsk.bskTypeDock === 'MailValidation') {
                <div class="col-12">
                  <inputvalue
                    [title]="'Val_Mail' | translate"
                    [dataVariableList]="paramDetail.bskParamDock.varList"
                    [libAction]="true"
                    [editorService]="paramDetail.editorService"
                    [visuMode]="!editMode"
                    >
                  </inputvalue>
                </div>
              }
              <!-- 2 eme ele -->
              @if (paramDetail.rightService.typeAction.TDAft) {
                <div class="col-12">
                  <attachedfile
                    [editMode]="editMode"
                    [listAtf]="paramDetail.docAtf"
                    [scroll]="true"
                    [atfActions]="paramDetail.atfActions"
                    [isLock]="paramDetail.isLock"
                    [docId]="paramDetail.currentDocId"
                    [docName]="paramDetail.currentDocName"
                  ></attachedfile>
                </div>
              }
            </div>
            <!-- 2 ere col -->
            <div class="flex flex-wrap flex-column md:flex-wrap"
                [ngClass]="{
                    'col-display-1': paramDetail.nbZoneDisplay.nbBskRight >= 1,
                    'col-display-2': paramDetail.nbZoneDisplay.nbBskLeft >= 1 && paramDetail.nbZoneDisplay.nbBskRight >= 1,
                    'col-display-false': paramDetail.nbZoneDisplay.nbBskRight === 0
                    }">
              <!-- 1er ele -->
              @if (paramDetail.displayBskVariableUpdate === true) {
                <div class="col-12">
                  <inputvalue
                    [visuMode]=!editMode
                    [title]="'Index_B' | translate"
                    [dataVariableList]="paramDetail.listBskVariableUpdate"
                    [libAction]="false"
                    [editorService]="paramDetail.editorService"
                    [btnUpdate]="paramDetail.isLock === false && editMode === true"
                    >
                  </inputvalue>
                </div>
              }
              <!-- 2 eme ele -->
              @if (originClick === '') {
                <div>
                  <commentaires class="linepad col-12"
                    #commentaires
                    [docId]="paramDetail.currentDocId"
                    [scroll]="true"
                    [addComm]="paramDetail.isLock === false && editMode === true"
                    [addNotif]="false"
                    [displayUserList]="false"
                  ></commentaires>
                </div>
              }
            </div>
          </div>
        </p-tabPanel>
      }
      <p-tabPanel>
        <ng-template pTemplate="header">{{'Doc_B' | translate}}</ng-template>
        <div class="flex flex-wrap">
          <!-- 1 ere col -->
          <div class="flex flex-wrap flex-column md:flex-wrap"
                    [ngClass]="{
                    'col-display-1': paramDetail.nbZoneDisplay.nbDocLeft >= 1,
                    'col-display-2': paramDetail.nbZoneDisplay.nbDocLeft >= 1 && paramDetail.nbZoneDisplay.nbDocRight >= 1,
                    'col-display-false': paramDetail.nbZoneDisplay.nbDocLeft === 0
                    }">
            <!-- 1er ele -->
            @if (paramDetail.rightService.typeAction.TDInfo) {
              <div class="col-12">
                <displayvalue class="col-12" [title]="'Infos' | translate" [dataLineList]="paramDetail.docInfos" [scroll]="true"></displayvalue>
              </div>
            }
            <!-- 2 eme ele -->
            @if (paramDetail.bskMode===false && paramDetail.rightService.typeAction.TDAft) {
              <attachedfile class="col-12"
                [editMode]="editMode"
                [listAtf]="paramDetail.docAtf"
                [scroll]="true"
                [atfActions]="paramDetail.atfActions"
                [isLock]="paramDetail.isLock"
                [docId]="paramDetail.currentDocId"
                [docName]="paramDetail.currentDocName"
              ></attachedfile>
            }
          </div>
          <!-- 2 eme col -->
          <div class="flex flex-wrap flex-column md:flex-wrap"
                [ngClass]="{
                    'col-display-1': paramDetail.nbZoneDisplay.nbDocRight >= 1,
                    'col-display-2': paramDetail.nbZoneDisplay.nbDocLeft >= 1 && paramDetail.nbZoneDisplay.nbDocRight >= 1,
                    'col-display-false': paramDetail.nbZoneDisplay.nbDockRight === 0
                    }">
            <!-- 1er ele -->
            @if (paramDetail.rightService.typeAction.TDVar) {
              @if (paramDetail.bskMode === true) {
                <div class="col-12">
                  <displayvalue class="col-12" [title]="'Index_B' | translate" [dataLineList]="paramDetail.docIndexFiltered" [scroll]="true"></displayvalue>
                </div>
              }
              @if (paramDetail.bskMode === false && paramDetail.displayBskVariableUpdate === true) {
                <div class="col-12">
                  @if (paramDetail.rightService.typeAction.TIdx === true) {
                    <div class="col-12">
                      <displayvalue class="col-12" [title]="'Index_B' | translate" [dataLineList]="paramDetail.docIndexFiltered" [scroll]="true"></displayvalue>
                    </div>
                  }@else {
                    <div class="col-12">
                      <displayvalue class="col-12" [title]="'Index_B' | translate" [dataLineList]="paramDetail.docIndexFiltered" [scroll]="true"></displayvalue>
                    </div>
                  }
                </div>
              }
            }
            <!-- 2 eme ele -->
            @if (paramDetail.bskMode===false && paramDetail.rightService.typeAction.TDCom && originClick === '') {
              <commentaires class="linepad col-12"
                #commentaires
                [docId]="paramDetail.currentDocId"
                [scroll]="true"
                [addComm]="paramDetail.rightService.typeAction.TAddCom && paramDetail.isLock === false && editMode === true"
                [addNotif]="false"
                [displayUserList]="false"
              ></commentaires>
            }
          </div>
        </div>
      </p-tabPanel>
      <!-- Dock Traçabilité : liste des bannettes, traces, circulation -->
      @if (paramDetail.rightService.typeAction.TDTra || paramDetail.rightService.typeAction.TBList) {
        <p-tabPanel>
          <ng-template pTemplate="header">{{'Follow' | translate}}</ng-template>
          <div class="flex flex-wrap">
            <!-- 1 ere col -->
            <div class="flex flex-wrap flex-column md:flex-wrap"
                    [ngClass]="{
                    'col-display-1': paramDetail.nbZoneDisplay.nbFollowLeft >= 1,
                    'col-display-2': paramDetail.nbZoneDisplay.nbFollowLeft >= 1 && paramDetail.nbZoneDisplay.nbFollowRight >= 1,
                    'col-display-false': paramDetail.nbZoneDisplay.nbFollowLeft === 0
                    }">
              <!-- 1er ele -->
              @if (paramDetail.rightService.typeAction.TDTra && originClick === '') {
                <traces [docId]="paramDetail.currentDocId" [scroll]="true"></traces>
              }
            </div>
            <!-- 2 eme col -->
            <div class="flex flex-wrap flex-column md:flex-wrap"
                    [ngClass]="{
                    'col-display-1': paramDetail.nbZoneDisplay.nbFollowRight >= 1,
                    'col-display-2': paramDetail.nbZoneDisplay.nbFollowLeft >= 1 && paramDetail.nbZoneDisplay.nbFollowRight >= 1,
                    'col-display-false': paramDetail.nbZoneDisplay.nbFollowRight === 0
                    }">
              <!-- 1er ele -->
              @if (paramDetail.rightService.typeAction.TBList) {
                <displayvalue [title]="'Baskets' | translate" [dataLineList]="paramDetail.docBasket" [scroll]="true"></displayvalue>
              }
            </div>
          </div>
        </p-tabPanel>
      }
      <!-- Dock version : versions -->
      @if (paramDetail.rightService.typeAction.TGVer && originClick === '') {
        <p-tabPanel>
          <ng-template pTemplate="header">{{'Versions' | translate}}
            <span class="small">{{ countVersion }}</span>
          </ng-template>
          <versionlist
            #versionlist
            [editMode]="editMode"
            [docId]="paramDetail.currentDocId"
            [delVer]="paramDetail.rightService.typeAction.TDel"
            [viewVer]="paramDetail.rightService.typeAction.TGVer"
            [isLock]="paramDetail.isLock"
            (onReadVer)="readVer($event)"
          ></versionlist>
        </p-tabPanel>
      }
    </p-tabView>
  </div>
}
